export enum SetupAssuranceSource {
	login = 'login',
	setPassword = 'setPassword',
}